import { ACTION } from '../../constants/actionTypes';

const locations = (state, { payload, type }) => {
  switch (type) {
    case ACTION.LOCATIONS.LOAD.REQUEST: {
      return {
        ...state,
        locations: {
          ...state.locations,
          loading: true,
        },
      };
    }
    case ACTION.LOCATIONS.LOAD.SUCCESS: {
      return {
        ...state,
        locations: {
          ...state.locations,
          loading: false,
          data: payload,
        },
      };
    }
    case ACTION.LOCATIONS.LOAD.ERROR: {
      return {
        ...state,
        locations: {
          ...state.locations,
          loading: false,
          error: payload,
        },
      };
    }

    default:
      return state;
  }
};

export default locations;
